export default [
    {
      path: '/admin/inventory/product-categories',
      name: 'product-category',
      meta: { requiresAuth: true },
      component: () => import('@/pages/inventory/product-category/index.vue')
    }
  ]
